import React, { useEffect } from "react";
import { AdminRoleOnly, ChargebeePortalSession } from "@/Contracts/Users";
import UsersActionCreators from "@/Actions/User";
import { GlobalState } from "@/Reducers/interface";
import ZMessage from "@molecules/ZMessage";
import { ZomentumWindow } from "@/Contracts";
import { useSelector } from "react-redux";
import useDispatch from "@/Components/Utils/useDispatch";

export interface Props {
	readonly onSubmit: () => void;
	readonly onClose: () => void;
}

declare let window: ZomentumWindow;

const CardFormComponent: React.FC<Props> = props => {
	const { billingInfo, isLoggedIn, userRole, portalSession } = useSelector(
		(state: GlobalState) => {
			return {
				isLoggedIn: state.login.isLoggedIn,
				userRole: state.user.userData?.role,
				billingInfo: state.user.billingInfo,
				portalSession: state.user.chargebeePortalSession
			};
		}
	);
	const dispatch = useDispatch();
	const getChargebeePortalSessionDispatch = () =>
		dispatch(UsersActionCreators.getChargebeePortalSession());

	const getSubscriptionOverviewDispatch = () =>
		dispatch(UsersActionCreators.getSubscriptionOverview());

	const showBillingInfoLoaderDispatch = () =>
		dispatch(UsersActionCreators.showBillingInfoLoader());
	const hideBillingInfoLoaderDispatch = () =>
		dispatch(UsersActionCreators.hideBillingInfoLoader());
	const initializeChargebee = async () => {
		showBillingInfoLoaderDispatch();
		try {
			const shouldFetchBillingInfo =
				isLoggedIn &&
				userRole &&
				AdminRoleOnly.includes(userRole) &&
				billingInfo;

			if (shouldFetchBillingInfo) {
				await getSubscriptionOverviewDispatch();
			}
		} catch (error) {
			console.error(error);
			ZMessage.error("Unable to fetch billing info!");
		}
		try {
			const { portalSession } = await getChargebeePortalSessionDispatch();
			renderPortalSession(portalSession);
		} catch (error) {
			console.error(error);
			ZMessage.error("Unable to initialise payment portal!");
		} finally {
			hideBillingInfoLoaderDispatch();
		}
	};

	useEffect(() => {
		initializeChargebee();
	}, []);

	const renderPortalSession = (newPortalSession: ChargebeePortalSession) => {
		const latestPortalSession = newPortalSession ?? portalSession;
		if (latestPortalSession) {
			const cbInstance = window.Chargebee.getInstance();
			const cbPortal = cbInstance.createChargebeePortal();
			cbInstance.setPortalSession(latestPortalSession);
			cbPortal.openSection(
				{
					sectionType:
						window.Chargebee.getPortalSections().PAYMENT_SOURCES
				},
				{
					paymentSourceUpdate: status => {
						if (status === "success") {
							cbInstance.closeAll();
							props.onSubmit();
						}
					},
					paymentSourceAdd: status => {
						if (status === "success") {
							cbInstance.closeAll();
							props.onSubmit();
						}
					},
					close: () => {
						props.onClose();
					}
				}
			);
		}
	};
	return <div className="card-details-form-container p-0" />;
};

export default CardFormComponent;
